import moment from 'moment';

const DATE_FORMAT = 'D MMM yyyy';

export function formatApplicationDate(date: string) {
  return moment(date).format(DATE_FORMAT);
}
